import React, { useEffect,useState } from "react";
import { deserialize } from 'jsonapi-fractal'
import axios from 'axios';
import ViewScheduleTable from "../ViewScheduleTable/ViewScheduleTable";
import Moment from 'react-moment';
import { isMobile } from 'react-device-detect';
import moment from 'moment';
import DataTable from "react-data-table-component";
import {fixedHeader,FixedHeaderStory} from 'react-data-table-component'

const ProductAccountTable = ({triggerDate,startDate,endDate,accountList,clientToken,borrowerAccount,loanDetailArr}) => {
    const [ledgerData,SetLedgerData] = useState([]);
    const [ledgerMeta,SetLedgerMeta] = useState([]);
    const [schedule,Setschedule] = useState(null);
    const [loanDisable,setLoanDisable]=useState(false);

    const [custFlag, setCustFlag] = useState(true);
    const [cashFlag, setCashFlag] = useState(false);
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(25)
    const [loading, setLoading] = useState(true);

    const scf_term = accountList  && (accountList.product_name === 'supply_chain' || accountList.product_name === 'term_loan');
    
    useEffect(()=>{
      if(triggerDate) {
        setPage(1)
        apiChange(1,perPage);
      }
    },[triggerDate]);

    useEffect(()=>{
       const retriveSch = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/v1/loan_repayment_schedules?q[loan_account_economic_loan_account_number_eq]=${accountList.loan_account_number}&q[loan_application_id_eq]=${accountList.loan_application_id}`,
        {
            headers: {
                'token': clientToken,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        })
        .then((res)=>{
          const data = deserialize(res.data)
          Setschedule(data)
        });
       };
       apiChange(page,perPage);

    },[]);

   const paymentPayloadLimit = (acclist) => {
        var loan_amount = 0;
        var flag = true;

        if(acclist.ba_acc.current_net_overdue && Number(acclist.current_net_overdue) > 0){
            loan_amount=acclist.ba_acc.current_net_overdue
        }else if (acclist.ba_acc.total_outstanding && Number(acclist.ba_acc.total_outstanding) > 0){
            loan_amount=acclist.ba_acc.total_outstanding;
        } else{
            flag = false;
        }

        if(!flag){
            return "";
        }else{
            return "?payload="+btoa(JSON.stringify({loan_id:acclist.ba_acc.id,loan_amount:loan_amount}));
        }
    }

    const convertCurrency = (a) => {
      let aTemp =  parseFloat(a);
      return aTemp.toLocaleString('en-IN');
    };

    const cusLedger = () => {
      setCustFlag(true);
      setCashFlag(false);
    }

    const cashLedger = () => {
      setCustFlag(false);
      setCashFlag(true);
    }

    const apiChange = (pageN,perpageN) => {
      setLoading(true)
      axios.get(`${process.env.REACT_APP_API_URL}/api/v1/loan_account_ledgers?q[loan_account_economic_loan_account_number_eq]=${accountList.loan_account_number}&q[payment_date_gteq]=${startDate}&q[payment_date_end_of_day_lteq]=${endDate}&page=${pageN}&per=${perpageN}`,
      {
          headers: {
              'token': clientToken,
              'Content-Type': 'application/json',
              'Accept': 'application/json'
          },
      })
      .then((res)=>{
        setLoading(false)
        const data = deserialize(res.data)
        SetLedgerData(data)
        SetLedgerMeta(res.data.meta)

        if(accountList.vpin_lf_flag === "lf"){
          axios.get(`${process.env.REACT_APP_API_URL}/api/v1/loan_repayment_schedules?q[loan_account_economic_loan_account_number_eq]=${accountList.loan_account_number}&q[loan_application_id_eq]=${accountList.loan_application_id}`,
          {
              headers: {
                  'token': clientToken,
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
              },
          })
          .then((res)=>{
            const data = deserialize(res.data)
            Setschedule(data)
          });
          }
        /*else if(accountList.vpin_lf_flag === "vp"){
          retriveOD();
        }*/

      });
    }

  
    const handlePageChange = (pageT) => {
      setPage(pageT);
      apiChange(pageT,perPage)
    }

    const handlePerRowsChange = (perpageT) => {
      setPerPage(perpageT);
      setPage(1);
      apiChange(1,perpageT)
    }
    
    const columnMobiles = [
      {
        name: ' ',
        selector: 'payment_date',
        cell: row => <div style={{display:"flex",}}><p style={{width:"140px",}}>Transaction date</p>
        <p >{row.payment_date}</p></div>,
        sortable: false,
      },
      {
          name: '',
          selector: "description",
          cell: row => <div style={{display:"flex",}}><p style={{width:"140px",}}>Narration </p>
          <p>{ row.description}</p></div>,
          sortable: false,
      },
      {
        name: '',
        selector: "debit_amount",
        cell: row => <div style={{display:"flex",}}><p style={{width:"140px",}}>Debit </p>
        <p>&#8377;{row.debit_amount}</p></div>,
        sortable: false,
    },
    {
        name: '',
        selector: "credit_amount",
        cell: row => <div style={{display:"flex",}}><p style={{width:"140px",}}>Credit </p>
        <p>{row.credit_amount}</p></div>,
        sortable: false,
    },
    {
      name: '',
      selector: "closing_balance",
      cell: row => <div style={{display:"flex",}}><p style={{width:"140px",}}>Closing Balance </p>
      <p>&#8377;{row.closing_balance}</p></div>,
      sortable: false,
    },
    {
        name: '',
        selector: "balance_to_repay",
        cell: row => <div style={{display:"flex",}}><p style={{width:"140px",}}> Principal Balance </p>
        <p>&#8377;{row.balance_to_repay}</p></div>,
        sortable: false,
    },
    {
      name: ' ',
      selector: "interest_balance_amount",
      cell: row => <div style={{display:"flex",}}><p style={{width:"140px",}}>Interest Balance </p>
      <p>-{row.interest_balance_amount}</p></div>,
      sortable: false,
    },
    {
        name: '',
        selector: "penalty_amount",
        cell: row => <div style={{display:"flex",}}><p style={{width:"140px",}}>Overdue Interest </p>
        <p>-{row.penalty_amoun}</p></div>,
        sortable: false,
    },
    ]

    const columns = [
      {
        name: 'Transaction Date',
        selector: 'payment_date',
        cell: row => row.payment_date,
        sortable: false,
      },
      {
          name: 'Narration',
          selector: "description",
          cell: row => <div style={{color:"#5AC4BE"}}>{row.description}</div>,
          sortable: false,
      },
      {
        name: 'Debit',
        selector: "debit_amount",
        cell: row => <span>&#8377;{row.debit_amount}</span>,
        sortable: false,
    },
    {
        name: 'Credit',
        selector: "credit_amount",
        cell: row => <span>-{row.credit_amount}</span>,
        sortable: false,
    },
    {
      name: 'Closing Balance',
      selector: "closing_balance",
      cell: row => <span>&#8377;{row.closing_balance}</span>,
      sortable: false,
    },
    {
        name: 'Principal Balance',
        selector: "balance_to_repay",
        cell: row => <span>&#8377;{row.balance_to_repay}</span>,
        sortable: false,
    },
    {
      name: ' Interest Balance',
      selector: "interest_balance_amount",
      cell: row => <span>-{row.interest_balance_amount}</span>,
      sortable: false,
    },
    {
        name: 'Overdue Interest',
        selector: "penalty_amount",
        cell: row => <span>-{row.penalty_amoun}</span>,
        sortable: false,
    },
    ];
    const customStylesMobile ={
      rows: {
        style: {
            paddingTop:"10px",
            backgroundColor:"#F5F5F5",
            display:"flex",
            flexDirection:"column"
        },
    },
    headCells: {
      style: {
        backgroundColor:"#F5F5F5",
      },
    },

    }
  const customStyles = {
    rows: {
        style: {
            minHeight: '80px',
        },
    },
    headCells: {
      style: {
          minHeight: '80px',
          marginTop:"20px",
          backgroundColor: "#9D9DA5",
          fontSize: "16px",
          fontWeight:"bold",
          color:"white",
      },
    },
    cells: {
      style: {
        fontSize: "16px",
      },
    },
  }

    return (
      <>
        <div className="col-md-12">
        {!isMobile ?   
        <div className="greenBox">
            <div className="row">
              <div className="col-md-2">
                  <div className="boxTrans">
                      <div style={{fontWeight: 'bold'}}>Mintifi Id</div>
                      <div>{accountList.loan_account_number}</div>
                  </div>
                  <div className="boxTrans" style={{textTransform: 'uppercase'}}>
                    {accountList.product_name.replace(/_/g, ' ')}
                  </div>
              </div>

              <div className="col-md-10 padd0">
                <div className="whiteBox">
                  
                  <div className="row payHeading">
                      <div className="col-md-2">
                          Sanctioned Limit
                      </div>
                      <div className="col-md-2">
                          Product Type
                      </div>
                      {scf_term &&
                        <div className="col-md-1">
                            ROI
                        </div>
                      }
                      <div className="col-md-1">
                          Tenure
                      </div>
                      <div className="col-md-2">
                          Expiry Date
                      </div>
                      <div className="col-md-2">
                          Anchor Name
                      </div>
                      <div className={`col-md-${scf_term ? '2' : '3'}`}>
                          Margin Money (if any)
                      </div>
                  </div>

                  <div className="row payHeadingDetails">
                      <div className="col-md-2 d-flex align-items-center justify-content-center" >
                          {accountList.limit_value ? 
                            <span>₹{convertCurrency(accountList.limit_value)}</span>
                           : "-"
                          }
                      </div>
                      <div className="col-md-2  d-flex align-items-center justify-content-center" style={{textTransform: 'uppercase'}}>
                          {accountList.product_name.replace(/_/g, ' ')}
                      </div>
                      {scf_term &&
                        <div className="col-md-1  d-flex align-items-center justify-content-center">
                            {accountList.roi ? `${accountList.roi}%` :  "-"}
                        </div>
                      }
                      <div className="col-md-1  d-flex align-items-center justify-content-center">
                          {accountList.ba_acc.tenure ? accountList.ba_acc.tenure : "-"}
                      </div>
                      <div className="col-md-2  d-flex align-items-center justify-content-center">
                          {accountList.limit_expiry ?
                            <>
                              <Moment format="DD MMM YYYY">{accountList.limit_expiry}</Moment>
                            </> :
                            "-"
                          }
                      </div>
                      <div className="col-md-2 d-flex align-items-center justify-content-center">
                          {accountList.ba_acc && accountList.ba_acc.anchor_logo_url &&
                            <img src={accountList.ba_acc.anchor_logo_url} alt="Anchor Logo" className="pl-1 pr-1" width="30px" />
                          }
                          {accountList.anchor_name}
                      </div>
                      <div className={`col-md-${scf_term ? '2' : '3'} d-flex align-items-center justify-content-center`}>
                           {accountList.ba_acc.cash_collateral ? 
                            <span>₹{convertCurrency(accountList.ba_acc.cash_collateral)}</span>
                           : "-"
                          }
                      </div>
                  </div>


                  <div className="row greenlightBox"> 
                     <div className="col-md-4"> 
                        <div className="greenHead">
                          Current Limit Utilised
                        </div>
                        <div className="greenHeadrow">
                          {accountList.limit_value ? 
                            <span>₹{convertCurrency(accountList.ba_acc.total_outstanding)}</span>
                           : "-"
                          }
                        </div>
                     </div>
                     {Number(accountList.current_net_overdue) > 0 ?
                       <>
                       <div className="col-md-3"> 
                          <div className="redHead">
                            Overdue
                          </div>
                          <div  className="greenHeadrow">
                            {accountList.current_net_overdue ? 
                              <span>₹{convertCurrency(accountList.current_net_overdue)}</span>
                             : "-"
                            }
                          </div>
                       </div>

                        <div className="col-md-3">
                          <div className="redHead">
                            Overdue Days
                          </div>
                          <div className="greenHeadrow">
                            {accountList.dpd_principal ? <><span className="dotRed"></span>{accountList.dpd_principal} days</> : "-"}
                          </div>
                       </div>

                        </>

                        :
                        <>
                        <div className="col-md-6"> 
                          &nbsp;
                       </div>
                       </>
                      }
                        <div className="col-md-2 text-center"> 
                           <a target="_blank" href="https://app.mintifi.com/repayment?utm_source=soa&utm_medium=repayment" className="buttonPay">PAY NOW</a>
                       </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
          :
          <div className="greenBox">
              <div className="col-md-2">
                  <div class="boxTrans">
                      <div style={{fontWeight: 'bold'}}>Mintifi Id</div>
                      <div>{accountList.loan_account_number}</div>
                  </div>
                  <div class="boxTrans" style={{textTransform: 'uppercase'}}>
                    {accountList.product_name.replace(/_/g, ' ')}
                  </div>
              </div>

              <div className="col-md-10 padd0">
                <div className="whiteBox" style={{margin:"10px"}}>
                  
                  <div className="payHeadingDetails" style={{borderRadius:"15px"}}>
                      <div className="d-flex justify-content-between" style={{padding:"5px"}}>
                        <div  style={{textAlign:"left"}}>
                          Sanctioned Limit:
                        </div>
                        <div style={{textAlign:"right"}}>
                            {accountList.limit_value ? 
                                <span>₹{convertCurrency(accountList.limit_value)}</span>
                            : "-"
                            }
                        </div>
                      </div>
                    <div className="d-flex justify-content-between" style={{padding:"5px"}}>
                      <div style={{textAlign:"left"}}>
                          Product Type:
                      </div>
                      <div style={{textAlign:"right",textTransform: 'uppercase'}}>
                          {accountList.product_name.replace(/_/g, ' ')}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between" style={{padding:"5px"}}>
                      <div style={{textAlign:"left"}}>
                          Tenure:
                      </div>
                      <div style={{textAlign:"right"}}>
                          {accountList.ba_acc.tenure ? accountList.ba_acc.tenure : "-"}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between" style={{padding:"5px"}}>
                      <div style={{textAlign:"left"}}>
                          Expiry Date:
                      </div>
                      <div style={{textAlign:"right"}}>
                           {accountList.limit_expiry ?
                            <>
                              <Moment format="DD MMM YYYY">{accountList.limit_expiry}</Moment>
                            </> :
                            "-"
                          }
                      </div>
                    </div>
                    <div className="d-flex justify-content-between" style={{padding:"5px"}}>
                      <div style={{textAlign:"left"}}>
                          Anchor Name:
                      </div>
                      <div style={{textAlign:"right"}}>
                          {accountList.ba_acc && accountList.ba_acc.anchor_logo_url &&
                            <img src={accountList.ba_acc.anchor_logo_url} alt="Anchor Logo" className="pl-1 pr-1" width="30px" />
                          }
                          {accountList.anchor_name}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between" style={{padding:"5px"}}>
                      <div style={{textAlign:"left"}}>
                           Margin Money (if any):
                      </div>
                      <div style={{textAlign:"right"}}>
                           {accountList.ba_acc.cash_collateral ? 
                            <span>₹{convertCurrency(accountList.ba_acc.cash_collateral)}</span>
                           : "-"
                          }
                      </div>
                    </div>
                  </div>

                  <div className="greenlightBox"> 
                     <div className="col-md-4"> 
                        <div className="greenHead">
                          Current Limit Utilised
                        </div>
                        <div className="greenHeadrow">
                          {accountList.limit_value ? 
                            <span>₹{convertCurrency(accountList.ba_acc.total_outstanding)}</span>
                           : "-"
                          }
                        </div>
                     </div>
                     {Number(accountList.current_net_overdue) > 0 ?
                       <>
                       <div className="col-md-3"> 
                          <div className="redHead">
                            Overdue
                          </div>
                          <div  className="greenHeadrow">
                            {accountList.current_net_overdue ? 
                              <span>₹{convertCurrency(accountList.current_net_overdue)}</span>
                             : "-"
                            }
                          </div>
                       </div>

                       <div className="col-md-3"> 
                          <div className="redHead">
                            Overdue Days
                          </div>
                          <div className="greenHeadrow">
                            <span className="dotRed"></span>{accountList.dpd_principal ? accountList.dpd_principal+" days" : "-"}
                          </div>
                       </div>

                       <div className="col-md-2"> 
                          <a target="_blank" href="https://app.mintifi.com/repayment?utm_source=soa&utm_medium=repayment" className="buttonPay">PAY NOW</a>
                       </div>

                        </>
                        :
                        <>
                        <div className="col-md-6"> 
                          &nbsp;
                       </div>
                        <div className="col-md-2"> 
                           <a target="_blank" href="https://app.mintifi.com/repayment?utm_source=soa&utm_medium=repayment" className="buttonPay">PAY NOW</a>
                       </div>
                       </>
                      }
                     

                  </div>

                </div>
              </div>

          </div>
        }
        </div>



        <div className="col-md-12 d-flex mt-2 mb-2 flex-column headcustomLedgerBox">
          <div className="headcustomLedger">
            <span className={custFlag === true ? "active" : ""} style={{cursor: "pointer"}} onClick={()=>cusLedger()}>Customer Ledger </span>
            {accountList && accountList.cc_data &&
              <span className={cashFlag === true ? "active" : ""} style={{cursor: "pointer"}} onClick={()=>cashLedger()}>Margin Money Ledger</span>
            }
          </div>
            <div className="table-responsive ">
            {custFlag === true ?
                       <DataTable
                       columns={isMobile ? columnMobiles : columns}
                       data={ledgerData}
                       pagination
                       progressPending={loading}
                       paginationServer
                       paginationTotalRows={ledgerMeta && ledgerMeta.total_count}
                       onChangeRowsPerPage={handlePerRowsChange}
                       onChangePage={handlePageChange}
                       paginationPerPage={perPage}
                       paginationRowsPerPageOptions={[25,50,100,150]}
                       customStyles={isMobile ? customStylesMobile : customStyles}
                       fixedHeader
                       />
                       :
                       <table className="table table-striped productAccounttable2">
                       {!isMobile &&
                       <thead>
                         <tr>
                           <th scope="col">Transaction Date</th>
                           <th scope="col">Narration</th>
                           <th scope="col">Debit</th>
                           <th scope="col">Credit</th>
                           <th scope="col">Remarks</th>
                         </tr>
                       </thead>
                       }
                       <tbody>
                       {!isMobile &&
                         <>
                           {accountList && accountList.cc_data && accountList.cc_data.transactions &&
                           accountList.cc_data.transactions.map((id,key)=>(
                             <tr key={"trledger"+key}>
                             <td >{id.transaction_date}</td>
                             <td className="greenDesp">{id.transaction_type}</td>
                             <td>{id.debit_amount ? "₹"+convertCurrency(id.debit_amount) : "-"}</td>
                             <td>{id.credit_amount ? "₹"+convertCurrency(id.credit_amount) : "-"}</td>
                             <td >{id.remarks ? id.remarks : "-"}</td>
                           </tr>
                           )) }
                         </>
                       }
                       {isMobile &&
                       <>
                       {accountList && accountList.cc_data && accountList.cc_data.transactions &&
                         accountList.cc_data.transactions.map((id,key)=>(
                           <tr key={"trledger"+key}>
                           <td>
                               <div className="d-flex d-All">
                                   <div className="d-lable pr-2">Transaction Date : </div>
                                   <div className="dataF">{id.transaction_date}</div>
                               </div>
                               <div className="d-flex d-All">
                                   <div className="d-lable pr-2">Narration :</div>
                                   <div className="dataFt">{id.transaction_type}</div>
                               </div>
                               <div className="d-flex d-All">
                                   <div className="d-lable pr-2">Debit :</div>
                                   <div className="dataF">{id.debit_amount ? "₹"+convertCurrency(id.debit_amount) : "-"}</div>
                               </div>
                               <div className="d-flex d-All">
                                   <div className="d-lable pr-2">Credit :</div>
                                   <div className="dataF">{id.credit_amount ? "₹"+convertCurrency(id.credit_amount) : "-"}</div>
                               </div>
                               <div className="d-flex d-All">
                                   <div className="d-lable pr-2">Remarks :</div>
                                   <div className="dataF">{id.remarks ? id.remarks : "-"}</div>
                               </div>
                           </td>
                           </tr>
                         )) }
                       </>
                       }
                       {ledgerData && ledgerData.length === 0 &&
                         <tr style={{backgroundColor:'none'}}><td className="text-center" colSpan="8">No entry found.</td></tr>
                       }
                       </tbody>
                     </table>
            }
          </div>
        </div>
        {schedule &&
          <ViewScheduleTable schedule={schedule} isMobile={isMobile} />
        }
      </>
    );
}
export default ProductAccountTable;
